export default "__VITE_ASSET__2000d3a9__"